import { render, staticRenderFns } from "./read.vue?vue&type=template&id=5ab9bf1c&scoped=true&"
import script from "./read.vue?vue&type=script&lang=js&"
export * from "./read.vue?vue&type=script&lang=js&"
import style0 from "./read.vue?vue&type=style&index=0&id=5ab9bf1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab9bf1c",
  null
  
)

export default component.exports